<template>
  <div>
    <template v-if="componentName === 'weather-forecast'">
      <weather-forecast></weather-forecast>
    </template>
    <template v-else-if="componentName === 'bathing-water-temperatures'">
      <bathing-water-temperatures :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></bathing-water-temperatures>
    </template>
    <template v-else-if="componentName === 'product-group-sales-table'">
      <product-group-sales-table></product-group-sales-table>
    </template>
    <template v-else-if="componentName === 'bookings-per-channel'">
      <bookings-per-channel></bookings-per-channel>
    </template>
    <template v-else-if="componentName === 'checkins-by-user'">
      <checkins-by-user></checkins-by-user>
    </template>
    <template v-else-if="componentName === 'checkouts-by-user'">
      <checkouts-by-user></checkouts-by-user>
    </template>
    <template v-else-if="componentName === 'checkins-and-checkouts-per-hour'">
      <checkins-and-checkouts-per-hour></checkins-and-checkouts-per-hour>
    </template>
    <template v-else-if="componentName === 'checkinouts-calendar'">
      <checkinouts-calendar></checkinouts-calendar>
    </template>
    <template v-else-if="componentName === 'checked-in-customers'">
      <checked-in-customers :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></checked-in-customers>
    </template>
    <template v-else-if="componentName === 'active-customers'">
      <active-customers></active-customers>
    </template>
    <template v-else-if="componentName === 'customer-nationalities'">
      <customer-nationalities></customer-nationalities>
    </template>
    <template v-else-if="componentName === 'revenue-numbers'">
      <revenue-numbers></revenue-numbers>
    </template>
    <template v-else-if="componentName === 'category-occupation-list'">
      <category-occupation-list :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></category-occupation-list>
    </template>
    <template v-else-if="componentName === 'category-occupation-radar'">
      <category-occupation-radar :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></category-occupation-radar>
    </template>
    <template v-else-if="componentName === 'category-occupation-polar'">
      <category-occupation-polar :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></category-occupation-polar>
    </template>
    <template v-else-if="componentName === 'total-occupation'">
      <total-occupation :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></total-occupation>
    </template>
    <template v-else-if="componentName === 'accommodation-value'">
      <accommodation-value></accommodation-value>
    </template>
    <template v-else-if="componentName === 'historical-turnover-full-accrual'">
      <historical-turnover-full-accrual></historical-turnover-full-accrual>
    </template>
    <template v-else-if="componentName === 'historical-turnover-part-accrual'">
      <historical-turnover-part-accrual></historical-turnover-part-accrual>
    </template>
    <template v-else-if="componentName === 'occupancy-stats'">
      <occupancy-stats :dashboard-card-settings="dashboardCardSettings" :pivot-id="pivotId" @updated-dashboard-card-settings="updatedDashboardCardSettings"></occupancy-stats>
    </template>
    <template v-else-if="componentName === 'position-turnover'">
      <position-turnover></position-turnover>
    </template>
    <template v-else-if="componentName === 'category-turnover'">
      <category-turnover></category-turnover>
    </template>
    <template v-else-if="componentName === 'position-occupation'">
      <position-occupation></position-occupation>
    </template>
    <template v-else-if="componentName === 'category-occupation'">
      <category-occupation></category-occupation>
    </template>
    <template v-else-if="componentName === 'yearly-guest-nights-summary'">
      <yearly-guest-nights-summary></yearly-guest-nights-summary>
    </template>
    <template v-else-if="componentName === 'access-control'">
      <access-control></access-control>
    </template>
    <template v-else>
      <v-alert type="error">Komponenten med namn "{{ componentName }}" kunde inte läsas in</v-alert>
    </template>

  </div>
</template>

<script>

export default {
  name: 'DashboardCard',
  components: {
    /* Endast komponenten som behövs laddas in */
    WeatherForecast: () => import('./WeatherForecast'),
    BathingWaterTemperatures: () => import('@/components/statistics/BathingWaterTemperatures'),
    ProductGroupSalesTable: () => import('@/components/statistics/ProductGroupSalesTable'),
    BookingsPerChannel: () => import('@/components/statistics/BookingsPerChannel'),
    CheckinsByUser: () => import('@/components/statistics/CheckinsByUser'),
    CheckoutsByUser: () => import('@/components/statistics/CheckoutsByUser'),
    CheckinsAndCheckoutsPerHour: () => import('@/components/statistics/CheckinsAndCheckoutsPerHour'),
    CheckinoutsCalendar: () => import('./CheckinoutsCalendar'),
    CheckedInCustomers: () => import('@/components/statistics/CheckedInCustomers'),
    ActiveCustomers: () => import('@/components/statistics/ActiveCustomers'),
    CustomerNationalities: () => import('@/components/statistics/CustomerNationalities'),
    RevenueNumbers: () => import('@/components/statistics/RevenueNumbers'),
    CategoryOccupationList: () => import('@/components/statistics/CategoryOccupationList'),
    CategoryOccupationRadar: () => import('@/components/statistics/CategoryOccupationRadar'),
    CategoryOccupationPolar: () => import('@/components/statistics/CategoryOccupationPolar'),
    TotalOccupation: () => import('@/components/statistics/TotalOccupation'),
    AccommodationValue: () => import('@/components/statistics/AccommodationValue'),
    HistoricalTurnoverFullAccrual: () => import('@/components/statistics/HistoricalTurnoverFullAccrual'),
    HistoricalTurnoverPartAccrual: () => import('@/components/statistics/HistoricalTurnoverPartAccrual'),
    OccupancyStats: () => import('@/components/statistics/OccupancyStats'),
    PositionTurnover: () => import('@/components/statistics/PositionTurnover'),
    CategoryTurnover: () => import('@/components/statistics/CategoryTurnover'),
    PositionOccupation: () => import('@/components/statistics/PositionOccupation'),
    CategoryOccupation: () => import('@/components/statistics/CategoryOccupation'),
    YearlyGuestNightsSummary: () => import('@/components/statistics/YearlyGuestNightsSummary'),
    AccessControl: () => import('./AccessControl')
  },
  props: {
    componentName: String,
    dashboardCardSettings: Object,
    pivotId: Number
  },
  data: () => ({}),
  computed: {},
  methods: {
    updatedDashboardCardSettings: function (param) {
      this.$emit('updated-dashboard-card-settings', param)
    }
  },
  mounted () {}
}
</script>
